import { render } from "./footerFrench.vue?vue&type=template&id=f7952072&lang=true"
import script from "./footerFrench.vue?vue&type=script&lang=js"
export * from "./footerFrench.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__